import { useParams } from 'react-router-dom'

import { useGetConfig } from '@jotta/grpc-connect-client/config'
import { I18nProvider, isLocale, useLocale } from '@jotta/i18n'
import { ErrorPageNotFound } from '@jotta/ui/ErrorPageNotFound'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { Redirect } from '@jotta/ui/Redirect'
import { useBrandCode } from '@jotta/ui/useBrandTheme'

import { PublicLayout } from '../components/Layout/PublicLayout'
import { PrivacySwitch } from '../privacy/PrivacySwitch'

function ConfigRedirect() {
  const { data } = useGetConfig()

  if (!data) {
    return <LoadingOverlay id="PrivacyRoute" open />
  }

  const privacyLink = data.brandingInfo?.privacyLink
  return privacyLink ? <Redirect to={privacyLink} /> : <ErrorPageNotFound />
}

export function PrivacyRoute() {
  const { fileName } = useParams()
  const brandCode = useBrandCode()
  const locale = useLocale()
  const localeParameter = fileName?.replace('.html', '')
  const overrideLocale = isLocale(localeParameter) ? localeParameter : locale

  return (
    <I18nProvider overrideLocale={overrideLocale}>
      <PublicLayout section="terms" className="prose mx-auto max-w-6xl">
        <PrivacySwitch
          brand={brandCode}
          locale={locale}
          Fallback={ConfigRedirect}
        />
      </PublicLayout>
    </I18nProvider>
  )
}
